import { CaseUserTimerStartRequest, StartTimerResult } from "interfaces/Mueller.Business.Models";
import { HTTP_GET, HTTP_POST, HTTP_PUT, WebApiRequest } from "tools/webservice";

const route = "/case-user-timers";

export const startTimer = (controlIdNumber: number, mountedRef, successCallback: (response: StartTimerResult) => void) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `${route}/timer/start`,
  successCallback,
  mountedRef,
  payload: { controlIdNumber: controlIdNumber } as CaseUserTimerStartRequest,
});

export const stopTimer = (timerId: number, mountedRef, successCallback: () => void) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `${route}/timer/${timerId}/stop`,
  successCallback,
  mountedRef,
});

export const getActiveTimer = (mountedRef, successCallback: (controlIdNumber: number) => void) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `${route}/timer/active`,
  successCallback,
  mountedRef,
});

export const pingTimer = (timerId: number, mountedRef, successCallback: () => void) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `${route}/timer/${timerId}/ping`,
  successCallback,
  mountedRef,
});
